module.exports = __webpack_public_path__ + "c12d39ae917818068564c079018b6c92.png";